<ui-popup-layout [injected]="true">
  <ui-popup-body>
    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
      <img class="tw-rounded-md tw-w-6 tw-h-6 tw-text-xl" [src]="icon$ | async"/>
      <h5 class="tw-text-lg tw-font-medium">{{ title$ | async }}</h5>
    </div>
    <div class="messages">
      <ng-container *ngFor="let message$ of messages$" >
        <span class="message tw-text-base-text/[.65]" [innerHTML]="message$ | async"></span>
      </ng-container>
    </div>
  </ui-popup-body>
</ui-popup-layout>
